import styled from 'styled-components';
import {
  monserratRegular,
  robotoRegular,
  scarpaGray900,
  scarpaGray500,
  scarpaGray600,
  scarpaGray200,
  scarpaGray50,
  electricPurple600,
  electricPurple100,
  electricPurple50,
  white,
} from '@habitech/shared';

export const SubjectCardWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 60px;
  z-index: 1000;
  background: ${white};
  border: 1px solid ${scarpaGray200};
  border-left: 4px solid ${electricPurple600};
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  min-width: 210px;
  font-family: ${robotoRegular};
`;

export const SubjectCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding-bottom: 7px;
  border-bottom: 1px solid ${electricPurple50};
`;

export const SubjectDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${electricPurple600};
  border: 2px solid ${electricPurple100};
  flex-shrink: 0;
`;

export const SubjectCardTitle = styled.span`
  font-weight: 400;
  font-size: 13px;
  color: ${electricPurple600};
  font-family: ${monserratRegular};
`;

export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin: 4px 0;
`;

export const CardRowLabel = styled.span`
  color: ${scarpaGray500};
  font-size: 11px;
  font-family: ${robotoRegular};
`;

export const CardRowValue = styled.span<{ $purple?: boolean }>`
  font-size: 11px;
  text-align: right;
  font-family: ${robotoRegular};
  color: ${({ $purple }) => ($purple ? electricPurple600 : scarpaGray900)};
  font-weight: ${({ $purple }) => ($purple ? 700 : 500)};
`;

export const LegendWrapper = styled.div`
  position: absolute;
  bottom: 30px;
  left: 60px;
  z-index: 1000;
  background: ${white};
  border: 1px solid ${scarpaGray200};
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  font-family: ${robotoRegular};
`;

export const LegendTitle = styled.p`
  font-weight: 400;
  color: ${scarpaGray500};
  font-size: 11px;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: ${monserratRegular};
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
  font-size: 12px;
  color: ${scarpaGray900};
  font-family: ${robotoRegular};
`;

export const LegendDot = styled.div<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;

export const LegendBadge = styled.span`
  background: ${scarpaGray50};
  border: 1px solid ${scarpaGray200};
  border-radius: 12px;
  padding: 1px 7px;
  font-size: 11px;
  margin-left: 4px;
`;

export const LegendPolygonSwatch = styled.div<{ $color: string }>`
  width: 16px;
  height: 10px;
  border-radius: 2px;
  border: 2px dashed ${({ $color }) => $color};
  background: ${({ $color }) => $color}14;
  flex-shrink: 0;
`;

export const NoDataNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: ${scarpaGray50};
  border: 1px solid ${scarpaGray200};
  border-radius: 6px;
  padding: 8px 10px;
  margin-top: 8px;
  font-size: 11px;
  color: ${scarpaGray600};
  line-height: 1.4;
  font-family: ${robotoRegular};
`;
